
export default function TestimonialsSection() {
  const testimonials = [
    {
      name: "T.S",
      company: "軽貨物運送会社A社",
      position: "採用担当",
      content: "月採用：10名",
      details: "業界：軽貨物運送会社A社\n募集職種：軽貨物運送ドライバー\n雇用形態：業務委託\n募集エリア：埼玉限定\n利用料金：月額50万円（基本料金35万円応募追加オプション利用）\n応募者数：月25名～30名",
      image: "https://public.readdy.ai/ai/img_res/abb860b0b2874434576a5984e184a1c5.jpg",
      rating: 5,
      results: "月採用：10名"
    },
    {
      name: "M.K", 
      company: "軽貨物運送会社B社",
      position: "採用担当",
      content: "月採用：15名",
      details: "業界：軽貨物運送会社B社\n募集職種：軽貨物運送ドライバー\n雇用形態：業務委託\n募集エリア：一都三県\n利用料金：月額35万円\n応募者数：月60名",
      image: "https://readdy.ai/api/search-image?query=Professional%20Japanese%20business%20manager%20at%20delivery%20service%20company%2C%20modern%20office%20background%2C%20confident%20business%20professional%2C%20corporate%20headshot%20style&width=80&height=80&seq=testimonial2&orientation=squarish",
      rating: 5,
      results: "月採用：15名"
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-6">
            <span className="text-blue-600">お客様の声</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            実際にドライバー集客をご利用いただいているお客様からの喜びの声をご紹介します
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
              <div className="text-center mb-6">
                <img 
                  src={testimonial.image}
                  alt={`${testimonial.company} ${testimonial.name}`}
                  className="w-20 h-20 rounded-full mx-auto mb-4 object-cover"
                />
                <h4 className="text-lg font-bold text-gray-800">{testimonial.company}</h4>
                <p className="text-gray-600 text-sm">{testimonial.position} {testimonial.name}</p>
              </div>

              <div className="mb-6">
                <div className="flex justify-center mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                  ))}
                </div>
                <div className="text-center mb-4">
                  <div className="bg-yellow-100 text-yellow-800 font-bold py-3 px-6 rounded-lg inline-block text-lg">
                    {testimonial.content}
                  </div>
                </div>
                <div className="text-gray-700 text-sm leading-relaxed whitespace-pre-line bg-gray-50 p-4 rounded-lg">
                  {testimonial.details}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-16">
          <div className="bg-blue-600 text-white rounded-xl p-8 max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold mb-4">
              <i className="ri-heart-line mr-2"></i>
              95%のお客様が継続してご利用いただいています
            </h3>
            <p className="text-lg">
              高い満足度と確かな実績で、多くの運送会社様に選ばれ続けています
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
